/* ALEPEO — Trouver mon rituel */
(function () {
  const RITUALS = {
    visage: {
      label: "Visage", icon: "◍",
      title: "Le rituel visage",
      intro: "Le geste du soir, celui qui compte le plus : il débarrasse la peau de la pollution, du sébum et des résidus de la journée. Le matin, un simple rinçage à l'eau claire suffit souvent aux peaux sèches.",
      meta: [["Durée","2 min 45"],["Fréquence","1 à 2 × / jour"],["Idéal","le soir"]],
      steps: [
        { t:"Mouiller le pain, pas le visage", s:10,
          d:"Passez le savon quelques secondes sous l'eau tiède. Une eau brûlante dissout le film hydrolipidique et fait tirailler.",
          tip:"Eau tiède, jamais chaude : autour de 35 °C, la température du corps." },
        { t:"Faire mousser entre les paumes", s:20,
          d:"Frottez le pain entre vos mains humides jusqu'à obtenir une mousse dense et crémeuse. Reposez le savon sur son porte-savon.",
          tip:"Ne frottez jamais le pain directement sur le visage : c'est trop abrasif et cela use le savon." },
        { t:"Appliquer du centre vers l'extérieur", s:45,
          d:"Déposez la mousse et massez du bout des doigts en petits cercles : front, nez, menton, puis joues. Contournez le contour des yeux.",
          tip:"Insistez sur la zone T si elle brille, allégez sur les joues si elles sont sèches." },
        { t:"Laisser la mousse travailler", s:30,
          d:"Ne rincez pas tout de suite. C'est pendant cette pause que l'huile de baies de laurier exerce son action assainissante.",
          tip:"Profitez-en pour respirer : trois inspirations lentes, le temps passe tout seul." },
        { t:"Rincer abondamment", s:30,
          d:"À l'eau tiède, jusqu'à disparition complète du film savonneux. Un rinçage incomplet laisse une sensation de tiraillement.",
          tip:"Terminez par quelques secondes d'eau fraîche pour resserrer les pores et raviver l'éclat." },
        { t:"Sécher en tamponnant", s:15,
          d:"Serviette propre et sèche, par petites pressions. Frotter irrite la peau et aggrave rougeurs et imperfections.",
          tip:"Changez de serviette visage tous les deux à trois jours." },
        { t:"Hydrater dans la foulée", s:25,
          d:"Sur peau encore légèrement humide, appliquez votre crème ou votre huile. C'est le geste qui scelle l'hydratation.",
          tip:"Même les peaux grasses ont besoin d'eau : choisissez une texture légère, non comédogène." }
      ]
    },
    corps: {
      label: "Corps", icon: "◐",
      title: "Le rituel corps",
      intro: "Sous la douche, le savon d'Alep remplace gel douche, savon de toilette et déodorant douteux. Un seul pain, deux huiles, aucun tensioactif de synthèse.",
      meta: [["Durée","3 min 30"],["Fréquence","1 × / jour"],["Idéal","douche du soir"]],
      steps: [
        { t:"Mouiller la peau à l'eau tiède", s:20,
          d:"Laissez l'eau tiédir la peau une vingtaine de secondes : les pores s'ouvrent et le savon agit mieux.",
          tip:"Coupez l'eau pendant le savonnage : vous économisez plusieurs litres à chaque douche." },
        { t:"Créer la mousse", s:25,
          d:"Faites mousser le pain entre vos mains, ou sur un gant de lin si vous aimez une exfoliation très douce.",
          tip:"Le savon d'Alep mousse peu et fin : c'est normal, c'est la signature d'un savon sans agent moussant ajouté." },
        { t:"Descendre de haut en bas", s:60,
          d:"Nuque et épaules, puis dos, torse, bras, ventre, jambes, pieds. Suivre toujours le même ordre évite d'oublier une zone.",
          tip:"Un gant de crin sur un manche long règle le problème du milieu du dos." },
        { t:"Insister sur les zones à sébum", s:35,
          d:"Dos, torse, aisselles, plis : ce sont les zones où le laurier fait la différence sur les odeurs et les boutons.",
          tip:"Après le sport, laissez agir deux minutes sur le dos et les épaules avant de rincer." },
        { t:"Laisser poser pendant la douche", s:45,
          d:"Profitez-en pour vous laver les cheveux ou simplement respirer sous la vapeur. Le temps de contact fait tout le travail.",
          tip:"C'est le secret des peaux à imperfections dans le dos : le temps, pas la friction." },
        { t:"Rincer, puis eau fraîche sur les jambes", s:35,
          d:"Rincez soigneusement, puis terminez par un jet d'eau fraîche des chevilles vers les cuisses.",
          tip:"Excellent pour la circulation et la sensation de jambes légères le soir." },
        { t:"Sécher et hydrater sous 3 minutes", s:30,
          d:"Tamponnez sans frotter, en insistant sur les plis, puis appliquez une huile ou un lait sur peau encore humide.",
          tip:"Passé trois minutes, l'eau s'est évaporée et l'hydratation est nettement moins efficace." }
      ]
    },
    cheveux: {
      label: "Cheveux", icon: "◒",
      title: "Le rituel cheveux",
      intro: "Utilisé en shampoing solide, le savon d'Alep assainit le cuir chevelu et régule les pellicules grasses. Une seule condition, mais elle est non négociable : le rinçage acide final.",
      meta: [["Durée","4 min"],["Fréquence","2 × / semaine"],["Adaptation","3 à 4 semaines"]],
      steps: [
        { t:"Démêler à sec", s:20,
          d:"Brossez soigneusement avant de mouiller : les cheveux mouillés sont fragiles et cassent facilement.",
          tip:"Commencez par les pointes et remontez vers les racines." },
        { t:"Mouiller très abondamment", s:25,
          d:"Les cheveux doivent être saturés d'eau, pas simplement humides, sinon le savon ne se répartira pas.",
          tip:"Comptez trente bonnes secondes sous l'eau tiède." },
        { t:"Appliquer sur le cuir chevelu", s:30,
          d:"Passez le pain directement sur les racines en trois ou quatre allers-retours, ou faites mousser entre les mains puis déposez.",
          tip:"Ne savonnez pas les longueurs : la mousse qui s'écoule au rinçage les nettoie suffisamment." },
        { t:"Masser du bout des doigts", s:60,
          d:"Massez le cuir chevelu par petits cercles, sans les ongles. C'est le massage qui décolle le sébum, pas la quantité de savon.",
          tip:"Le massage stimule aussi la microcirculation : ne l'expédiez pas." },
        { t:"Rincer deux fois plus longtemps", s:80,
          d:"Le rinçage est l'étape la plus souvent bâclée. Rincez jusqu'à ce que les cheveux crissent légèrement sous les doigts.",
          tip:"Un rinçage insuffisant est la cause numéro un de l'effet poisseux attribué à tort au savon." },
        { t:"Le rinçage acide, indispensable", s:45,
          d:"Une cuillère à soupe de vinaigre de cidre dans un litre d'eau froide, versée sur les longueurs, puis rincez légèrement.",
          tip:"Il neutralise le pH alcalin, referme les écailles et rend la brillance. Sans lui, effet paille garanti." },
        { t:"Essorer et sécher à l'air", s:20,
          d:"Pressez dans une serviette en microfibre ou un tee-shirt en coton, sans frictionner.",
          tip:"Les trois premières semaines, le cuir chevelu se rééquilibre : ne renoncez pas trop vite." }
      ]
    },
    masque: {
      label: "Masque", icon: "◉",
      title: "Le masque hebdomadaire",
      intro: "Réservé aux peaux grasses, mixtes ou à imperfections, et aux concentrations de 30 % et 40 %. C'est un soin, pas un nettoyage : une à deux fois par semaine suffisent largement.",
      meta: [["Durée","7 min"],["Fréquence","1 à 2 × / semaine"],["Dosage","30 % ou 40 %"]],
      steps: [
        { t:"Nettoyer d'abord", s:30,
          d:"Un masque ne s'applique jamais sur une peau maquillée ou chargée. Faites le rituel visage court avant.",
          tip:"Peau propre et légèrement humide : le masque adhère mieux." },
        { t:"Préparer une mousse épaisse", s:30,
          d:"Faites mousser plus longuement que d'habitude, jusqu'à obtenir une texture presque crémeuse.",
          tip:"Un bol et un blaireau de rasage donnent la mousse la plus dense en quelques secondes." },
        { t:"Appliquer en couche généreuse", s:40,
          d:"Étalez sur l'ensemble du visage en évitant soigneusement le contour des yeux et les lèvres.",
          tip:"Vous pouvez cibler uniquement la zone T si vos joues sont sèches." },
        { t:"Laisser poser", s:180,
          d:"Trois minutes pour une première fois, jusqu'à cinq minutes ensuite. La mousse sèche légèrement, c'est normal.",
          tip:"Si ça picote franchement, rincez immédiatement : votre peau vous dit que c'est trop." },
        { t:"Réactiver à l'eau tiède", s:20,
          d:"Humidifiez vos mains et massez le masque séché pour le réémulsionner avant de rincer.",
          tip:"Cette réactivation vaut un micro-gommage tout en douceur." },
        { t:"Rincer soigneusement", s:35,
          d:"À l'eau tiède, puis un dernier passage à l'eau fraîche. Aucun résidu ne doit rester.",
          tip:"Vérifiez la lisière des cheveux et les ailes du nez, souvent oubliées." },
        { t:"Apaiser et hydrater", s:35,
          d:"Une crème apaisante non comédogène, immédiatement. La peau vient de travailler, elle a besoin de confort.",
          tip:"Évitez les actifs puissants — acides, rétinol — le soir du masque." }
      ]
    },
    bebe: {
      label: "Bébé", icon: "◌",
      title: "Le rituel des tout-petits",
      intro: "Avec un savon à 4 % de laurier uniquement. La peau d'un nourrisson est trois à cinq fois plus fine que celle d'un adulte : douceur maximale, et jamais tous les jours.",
      meta: [["Durée","3 min"],["Fréquence","2 à 3 × / semaine"],["Dosage","4 % exclusivement"]],
      steps: [
        { t:"Test de tolérance 24 h avant", s:20,
          d:"Une trace de mousse au creux du bras, rincée après une minute. Attendez 24 heures et vérifiez l'absence de rougeur.",
          tip:"Ce test se refait à chaque changement de produit, même naturel." },
        { t:"Préparer le bain à 37 °C", s:30,
          d:"Vérifiez la température au thermomètre ou au coude. Rassemblez serviette, vêtements et crème à portée de main.",
          tip:"Ne quittez jamais la pièce et gardez toujours une main sur l'enfant pendant le bain." },
        { t:"Faire mousser dans vos mains", s:20,
          d:"Le pain ne touche jamais la peau du bébé. Vous n'appliquez que la mousse, avec vos mains.",
          tip:"Une noisette de mousse suffit pour tout le corps." },
        { t:"Laver le corps en douceur", s:45,
          d:"Nuque, torse, bras, jambes, puis les plis du cou, des aisselles et de l'aine. Terminez toujours par le siège.",
          tip:"Les plis d'abord, le siège en dernier : c'est la règle d'hygiène de base." },
        { t:"Le cuir chevelu, très délicatement", s:25,
          d:"Une fine couche de mousse, massée à plat avec la pulpe des doigts, sans appuyer sur la fontanelle.",
          tip:"Sur les croûtes de lait, ne grattez jamais : huile végétale la veille, puis lavage doux." },
        { t:"Rincer parfaitement", s:35,
          d:"Aucun résidu ne doit rester, surtout dans les plis. C'est l'étape la plus importante du bain.",
          tip:"Rincez à l'eau claire tiède, en soutenant bien la tête." },
        { t:"Sécher les plis et hydrater", s:35,
          d:"Tamponnez et séchez soigneusement chaque pli, puis appliquez un liniment ou une crème émolliente.",
          tip:"Une peau bien séchée dans les plis, c'est zéro rougeur et zéro macération." }
      ]
    }
  };

  function fmt(s){ const m=Math.floor(s/60), r=s%60; return m ? m+":"+String(r).padStart(2,"0") : String(r); }

  function init(root){
    if (root.dataset.aleprtReady) return;
    root.dataset.aleprtReady = "1";

    const tabsWrap = root.querySelector("[data-aleprt-tabs]");
    const stepsWrap= root.querySelector("[data-aleprt-steps]");
    const player   = root.querySelector("[data-aleprt-player]");
    const anchor   = root.querySelector("[data-aleprt-card]");
    let key = "visage", timer = null, idx = 0, left = 0, paused = false, sound = true;

    // onglets
    Object.keys(RITUALS).forEach((k,i)=>{
      const b = document.createElement("button");
      b.type="button"; b.className="aleprt__tab"+(i===0?" is-on":"");
      b.dataset.k=k; b.setAttribute("role","tab");
      b.innerHTML = '<span aria-hidden="true">'+RITUALS[k].icon+'</span><b>'+RITUALS[k].label+'</b>';
      tabsWrap.appendChild(b);
    });

    tabsWrap.addEventListener("click", e=>{
      const b = e.target.closest(".aleprt__tab"); if(!b) return;
      stop();
      key = b.dataset.k;
      tabsWrap.querySelectorAll(".aleprt__tab").forEach(t=>t.classList.toggle("is-on", t===b));
      paint();
    });

    function paint(){
      const r = RITUALS[key];
      root.querySelector("[data-aleprt-title]").textContent = r.title;
      root.querySelector("[data-aleprt-intro]").textContent = r.intro;
      root.querySelector("[data-aleprt-meta]").innerHTML =
        r.meta.map(m=>'<span class="aleprt__chip">'+m[0]+' <b>'+m[1]+'</b></span>').join("");
      stepsWrap.innerHTML = r.steps.map((s,i)=>
        '<li class="aleprt__step" data-i="'+i+'"><span class="aleprt__num"></span>'+
        '<span class="aleprt__stxt"><strong>'+s.t+'</strong><span>'+s.d+'</span>'+
        (s.tip?'<span class="aleprt__stip">'+s.tip+'</span>':'')+'</span>'+
        '<span class="aleprt__sdur">'+fmt(s.s)+' s</span></li>').join("");
    }

    // audio
    let ctx=null;
    function chime(){
      if(!sound) return;
      try{
        ctx = ctx || new (window.AudioContext||window.webkitAudioContext)();
        const o=ctx.createOscillator(), g=ctx.createGain();
        o.type="sine"; o.frequency.value=660;
        g.gain.setValueAtTime(0,ctx.currentTime);
        g.gain.linearRampToValueAtTime(.18,ctx.currentTime+.02);
        g.gain.exponentialRampToValueAtTime(.0001,ctx.currentTime+.6);
        o.connect(g).connect(ctx.destination); o.start(); o.stop(ctx.currentTime+.62);
      }catch(e){}
      if (navigator.vibrate) navigator.vibrate(60);
    }

    function setStep(i){
      const r = RITUALS[key];
      if (i >= r.steps.length){ finish(); return; }
      idx = i; left = r.steps[i].s;
      root.querySelector("[data-aleprt-pnow]").textContent = "Étape "+(i+1)+" / "+r.steps.length;
      root.querySelector("[data-aleprt-ptitle]").textContent = r.steps[i].t;
      root.querySelector("[data-aleprt-pdesc]").textContent = r.steps[i].d;
      stepsWrap.querySelectorAll(".aleprt__step").forEach((el,j)=>{
        el.classList.toggle("is-now", j===i);
        el.classList.toggle("is-done", j<i);
      });
      const now = stepsWrap.querySelector(".is-now");
      if (now) now.scrollIntoView({block:"nearest",behavior:"smooth"});
      tick(true);
    }

    function tick(silent){
      const total = RITUALS[key].steps[idx].s;
      root.querySelector("[data-aleprt-count]").textContent = left;
      root.querySelector("[data-aleprt-ring]").style.strokeDashoffset =
        (339.29 * (1 - left/total)).toFixed(1);
      if (!silent && left <= 0){ chime(); setStep(idx+1); }
    }

    function start(){
      player.classList.add("is-on");
      paused = false; setPlayIcon();
      setStep(0);
      clearInterval(timer);
      timer = setInterval(()=>{ if(!paused){ left--; tick(); } }, 1000);
      const y = anchor.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({top:y, behavior:"smooth"});
    }
    function stop(){
      clearInterval(timer); timer=null;
      player.classList.remove("is-on");
      stepsWrap.querySelectorAll(".aleprt__step").forEach(el=>el.classList.remove("is-now","is-done"));
    }
    function finish(){
      clearInterval(timer); timer=null;
      root.querySelector("[data-aleprt-pnow]").textContent = "Rituel terminé";
      root.querySelector("[data-aleprt-ptitle]").textContent = "C'est fait. Belle peau à vous.";
      root.querySelector("[data-aleprt-pdesc]").textContent =
        "La régularité compte plus que l'intensité : c'est en trois à quatre semaines que les résultats deviennent visibles.";
      root.querySelector("[data-aleprt-count]").textContent = "✓";
      root.querySelector("[data-aleprt-ring]").style.strokeDashoffset = 0;
      stepsWrap.querySelectorAll(".aleprt__step").forEach(el=>{
        el.classList.remove("is-now"); el.classList.add("is-done");
      });
      try{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event:"alep_ritual_completed", ritual:key});
      }catch(e){}
    }
    function setPlayIcon(){
      root.querySelector("[data-aleprt-play]").innerHTML = paused
        ? '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>'
        : '<svg viewBox="0 0 24 24"><path d="M6 4h4v16H6zM14 4h4v16h-4z"/></svg>';
    }

    root.querySelector("[data-aleprt-start]").addEventListener("click", start);
    root.querySelector("[data-aleprt-play]").addEventListener("click", ()=>{ paused=!paused; setPlayIcon(); });
    root.querySelector("[data-aleprt-next]").addEventListener("click", ()=> setStep(idx+1));
    root.querySelector("[data-aleprt-prev]").addEventListener("click", ()=> setStep(Math.max(0, idx-1)));
    root.querySelector("[data-aleprt-quit]").addEventListener("click", stop);
    const snd = root.querySelector("[data-aleprt-sound]");
    snd.addEventListener("click", ()=>{
      sound = !sound;
      snd.setAttribute("aria-pressed", String(sound));
      snd.innerHTML = sound
        ? '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3a4.5 4.5 0 00-2.5-4v8a4.5 4.5 0 002.5-4z"/></svg>'
        : '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm16 0l-1.4-1.4L15 10.2 12.4 7.6 11 9l2.6 2.6L11 14.2l1.4 1.4 2.6-2.6 2.6 2.6L19 14.2l-2.6-2.6L19 9z"/></svg>';
    });

    document.addEventListener("visibilitychange", ()=>{ if(document.hidden && timer){ paused=true; setPlayIcon(); }});

    paint(); setPlayIcon();
  }

  function boot(){ document.querySelectorAll("[data-aleprt]").forEach(init); }
  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
  if (document.readyState !== "loading") boot();
})();
